import { format, parseISO } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useLocation, useRouteMatch } from 'react-router';
import { useHistory } from 'react-router-dom';
import Loading from '../../components/Loading';
import PacienteCabecalho from '../../components/PacienteCabecalho';
import { useClinica } from '../../hooks/clinica';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import {
  formataCPF,
  formataIdade,
  formataTelefone,
  formatPrice,
} from '../../utils/funcoes';
import getResponseErrors from '../../utils/getResponseErrors';
import { ITratamento } from '../ListaOrcamentos';
import { IPacienteCodigo } from '../PacienteAtendimento';
import Odonto from '../PacienteAtendimento/Odonto';

// import { Container } from './styles';

interface IUrlParams {
  id: string;
}

interface IPropsLocation {
  plano: boolean;
}

const Orcamento: React.FC = () => {
  const location = useLocation();
  const { addToast } = useToast();
  const { imagensClinica } = useClinica();
  const history = useHistory();
  const { params } = useRouteMatch<IUrlParams>();
  const { id } = params;

  const { plano } = location.state as IPropsLocation;

  const [tratamento, setTratamento] = useState<ITratamento | undefined>(
    undefined,
  );

  const [paciente, setPaciente] = useState<IPacienteCodigo | undefined>(
    undefined,
  );

  const [loading, setLoading] = useState(false);

  const semFoto =
    imagensClinica.find(img => img.nome === 'semFoto')?.arquivo_url || '';

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get(`/tratamento/${id}`);
        const responseTratamento: ITratamento = response.data;

        const response2 = await api.get(
          `/pacientes/${responseTratamento.PacCodigo}`,
        );
        const responsePaciente: IPacienteCodigo = response2.data;

        setPaciente({
          ...responsePaciente,
          PacTelefone: formataTelefone(responsePaciente.PacTelefone),
          PacCelular: formataTelefone(responsePaciente.PacCelular),
          PacCPF: formataCPF(responsePaciente.PacCPF),
          PacDataNascFormatada: format(
            parseISO(responsePaciente.PacDataNasc),
            'dd/MM/yyyy',
          ),
          PacIdade: formataIdade(parseISO(responsePaciente.PacDataNasc)),
          avatar_url: responsePaciente.avatar_url || semFoto,
        });

        const tratamentoFormatado = {
          ...responseTratamento,
          dataFormatada: format(
            parseISO(responseTratamento.created_at.toString()),
            'dd/MM/yyyy',
          ),
          // tipoFormatado: TIPO_TRATAMENTO_NOME[responseTratamento.tipo],
          valorFormatado: formatPrice(responseTratamento.valor),
          statusFormatado: responseTratamento.finalizado ? 'Sim' : 'Não',
        };
        setTratamento(tratamentoFormatado);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar Pedido de Exames',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }

    if (id && semFoto !== '') loadDados();
  }, [addToast, id, semFoto]);

  return (
    <>
      <Container fluid className="mt-2">
        {loading && <Loading />}
        <div className="mb-2 p-2 bg-white border rounded">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <h6 id="topoBusca">Dados Tratamento</h6>
            <Button
              type="button"
              variant="outline-primary"
              size="sm"
              onClick={() => history.push('/tratamentos')}
            >
              Voltar para orçamentos
            </Button>
          </div>
          {paciente && <PacienteCabecalho paciente={paciente} />}
        </div>
        {tratamento && (
          <div className="mb-2 p-2 bg-white border rounded">
            <Odonto
              dadosAgendamento={{
                pacienteID: tratamento.PacCodigo,
                agePlano: plano,
                AgeCodigo: tratamento.AgeCodigo,
              }}
              medUsuCodigo={tratamento.MedUsuCodigo}
              buscaOutrosMedicos={false}
              bloqueado
              idTratamento={tratamento.id}
            />
          </div>
        )}
      </Container>
    </>
  );
};

export default Orcamento;
